// Routes
export const dashboardRoute = '/dashboard'
export const login = '/login'
export const scheduleAppointment = '/schedule_appointment'
export const secureMessaging = '/messages'
export const secureMessagingV3 = '/chats'
export const profileRoute = '/:caseId/profile/:id'
export const personalInfoRoute = `${profileRoute}/personal`
export const contactInfoRoute = `${profileRoute}/contacts`
export const employmentsInfoRoute = `${profileRoute}/employment`

// Onboarding  routes
export const onboardingRoute = '/onboarding'
export const onboardingDetailsRoute = '/onboarding/details'
export const onboardingIddRoute = '/onboarding/idd'

// Credit reporting
export const creditOverviewRoute = '/:caseId/credit/overview'
export const creditIddRoute = '/:caseId/credit/disclosure'
export const identityChecksRoute = '/:caseId/credit/id-checks'
export const eidvRoute = '/:caseId/credit/id-checks/result'
export const kbaIddRoute = '/:caseId/credit/security/terms-and-conditions'
export const kbaQuestionsRoute = '/:caseId/credit/security/questions'

// Credit details
export const creditDetailsRoute = '/credit-details'

// Documents routes
export const documentsRoute = '/documents'
export const documentsCaseRoute = '/documents/:caseId'
export const documentsClientRoute = '/client_documents/:clientId'
export const documentsModalPreview = '/documents/preview/:id'
export const documentsModalPreviewCase = '/documents/:caseId/preview/:id'
export const documentsModalPreviewClient = '/client_documents/:clientId/preview/:id'
export const documentsUploadRoute = '/document-upload/*'
export const documentsProofOfIdORoute = '/documents/id'
export const documentsProofOfAddressRoute = '/documents/address'
export const documentsProofOfIncomeRoute = '/documents/income'
export const documentsBankStatementRoute = '/documents/banking-statement'
export const documentsAdditionalRoute = '/documents/other'
export const documentsPreview = '/preview/:id'

// Document upload routes
export const documentUploadRoute3 = '/:caseId/document-upload'
export const proofOfAddressRoute3 = '/:caseId/document-upload/address'
export const proofOfIncomeRoute3 = '/:caseId/document-upload/income'
export const bankingStatementRoute3 = '/:caseId/document-upload/banking'
export const additionalDocumentsRoute3 = '/:caseId/document-upload/other'

export const proofOfAddressRoute = '/document-upload/address'
export const proofOfIncomeRoute = '/document-upload/income'
export const bankingStatementRoute = '/document-upload/banking'
export const additionalDocumentsRoute = '/document-upload/other'

// Helpers
export const emptyVal = '-'

// Requirements routes
export const requirementsRoute = '/:caseId/requirements'
export const yourSituationRoute = `${requirementsRoute}/situation`
export const yourDepositsRoute = `${requirementsRoute}/deposits`
export const aboutPropertyRoute = `${requirementsRoute}/property`
export const preferencesRoute = `${requirementsRoute}/preferences`
export const conveyancerRoute = `${requirementsRoute}/conveyancer`
export const otherPropertiesRoute = `${requirementsRoute}/other-properties`
export const committedExpenditureRoute = `${requirementsRoute}/committed-expenditure`
export const discretionaryExpenditureRoute = `${requirementsRoute}/discretionary-expenditure`

// Vulnerability assessment
export const vulnerabilityAssessmentRoute = `/:caseId/wellbeing-assessment/:assessmentUUID`

// Protection
export const protectionAdviceRoute = `${requirementsRoute}/protection/advice`

// Cross sales
export const willsRoute = '/wills/:caseId'
export const surveyingRoute = '/surveying/:caseId'

// Property Data
export const propertiesRoute = '/properties'
export const propertyInfoRoute = `${propertiesRoute}/property-info/:propertyId`
export const propertyInfoEPCRoute = `${propertiesRoute}/property-info/:propertyId/epc`

// Ory Login
export const oryLogin = '/ory-login'
export const createPassword = '/settings'
export const oryVerification = '/verification'
export const oryEmailVerification = '/email_recovery'
export const settings = '/password'
export const phoneSelection = '/phone_selection'
export const oryRecovery = '/recovery'
export const noInvite = '/no_invite'

// Conveyancing
export const conveyancing = '/conveyancing/:caseId/quote'
export const conveyancingFactFind = '/conveyancing/:caseId/fact-find'
export const conveyancingFactFindProperty = `${conveyancingFactFind}/property`
export const conveyancingFactFindNewProperty = `${conveyancingFactFind}/new-property`
export const conveyancingFactFindPersonalInfo = `${conveyancingFactFind}/about`
export const conveyancingFactFindMortgage = `${conveyancingFactFind}/mortgage`
export const conveyancingFactFindCompleted = `${conveyancingFactFind}/completed`

// Checklist
export const checklistRoute = '/homebuyers-checklist/:caseId'

// Go Cardless
export const paymentCompleteRoute = '/go-cardless-payment-return'
export const paymentFailedRoute = '/go-cardless-payment-rejected'

// Case dashboard
export const caseDashboardRoute = '/cases/:caseId/dashboard'

// Settings
export const settingsRoute = '/portal-settings'
export const creditSettings = '/portal-settings/credit'
export const dataPreferences = '/portal-settings/preferences'
export const notificationSettings = '/portal-settings/notifications'
export const passkeysSettings = '/portal-settings/passkeys'

//Tradesmen
export const tradesmenRoute = '/tradesmen'

export const surveyRoute = '/survey'

// Health fact find
export const healthFactFindRoute = '/:caseId/health/:clientId'
export const healthFactFindGPRoute = `${healthFactFindRoute}/gp-information`
export const healthFactFindLifestyleRoute = `${healthFactFindRoute}/lifestyle`
export const healthFactFindMedicalHistoryRoute = `${healthFactFindRoute}/medical-history`
export const healthFactFindFamilyMedicalHistoryRoute = `${healthFactFindRoute}/family-medical-history`
